import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Button from '@kurtosys/ksys-app-components/dist/components/base/Button';

export default InjectedStyledComponent(Button, 'impersonation', ['impersonateUserRow']);